'use strict';

/**
 * @ngdoc service
 * @name gfcmsApp.events,service
 * @description
 * # events,service
 * Service in the gfcmsApp.
 */
angular.module('gfcmsApp')
  .service('eventsService', function($rootScope, $window) {
    var eventsService = {};
    eventsService.loggedInEvent = 'eventsService.loggedIn';
    eventsService.loggedOutEvent = 'eventsService.loggedOut';
    eventsService.loggedOutStartEvent = 'eventsService.loggedOutStart';
    eventsService.profileUpdatedEvent = 'eventsService.profileUpdated';
    eventsService.permissionsChangedEvent = 'eventsService.permissionsChanged';
    eventsService.onBeforeUnloadEvent = 'eventsService.pageUnloaded';
    eventsService.routeChangeStartEvent = '$routeChangeStart';
    eventsService.locationChangeStartEvent = '$locationChangeStart';

    eventsService.loggedIn = loggedIn;
    eventsService.loggedOut = loggedOut;

    eventsService.loggedOutStart = loggedOutStart;
    eventsService.profileUpdated = profileUpdated;
    eventsService.permissionsChanged = permissionsChanged;
    eventsService.initializeOnBeforeUnload = initializeOnBeforeUnload;
    eventsService.subscribe = subscribe;

    function loggedIn() {
      $rootScope.$broadcast(eventsService.loggedInEvent);
    }

    function loggedOut() {
      $rootScope.$broadcast(eventsService.loggedOutEvent);
    }

    function loggedOutStart() {
      return $rootScope.$broadcast(eventsService.loggedOutStartEvent);
    }

    function profileUpdated() {
      $rootScope.$broadcast(eventsService.profileUpdatedEvent);
    }

    function permissionsChanged() {
      $rootScope.$broadcast(eventsService.permissionsChangedEvent);
    }

    function onBeforeUnloadBroadcast() {
     return $rootScope.$broadcast(eventsService.onBeforeUnloadEvent);
    }

    function initializeOnBeforeUnload() {
     $window.onbeforeunload = onBeforeWindowUnload;
    }

    function onBeforeWindowUnload(event) {
      var onBeforeUnloadEvent = onBeforeUnloadBroadcast();
      var confirmation = {
        message: 'Are you sure'
      };
      if (onBeforeUnloadEvent.defaultPrevented) {
        return confirmation.message;
      }
    }

    function subscribe(eventKey, eventHandler) {
      if (!eventHandler) {
        throw new Error('eventHandler cannot be undefined');
      }

      return $rootScope.$on(eventKey, eventHandler);
    }

    return eventsService;
  });
